import { render, staticRenderFns } from "./PayerGroupModal.vue?vue&type=template&id=e2f8966a&scoped=true&"
import script from "./PayerGroupModal.vue?vue&type=script&lang=ts&"
export * from "./PayerGroupModal.vue?vue&type=script&lang=ts&"
import style0 from "./PayerGroupModal.vue?vue&type=style&index=0&id=e2f8966a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f8966a",
  null
  
)

export default component.exports